export const MIN_MODAL_ZOOM = 1;
export const MAX_MODAL_ZOOM = 8;
export const MODAL_ZOOM_STEP = 0.25;
export const MODAL_MOBILE_QUERY =
  '(max-width: 767px), (max-width: 900px) and (orientation: landscape)';

export const clampModalZoom = (value) =>
  Math.max(MIN_MODAL_ZOOM, Math.min(MAX_MODAL_ZOOM, value));

export const getModalPanBounds = ({
  fittedHeight,
  fittedWidth,
  viewportHeight,
  viewportWidth,
  zoom,
}) => {
  if (zoom <= MIN_MODAL_ZOOM) return { x: 0, y: 0 };

  return {
    x: Math.max(0, fittedWidth * zoom - viewportWidth) / 2,
    y: Math.max(0, fittedHeight * zoom - viewportHeight) / 2,
  };
};

export const clampModalPan = (position, bounds) => ({
  x: Math.max(-bounds.x, Math.min(bounds.x, position.x)),
  y: Math.max(-bounds.y, Math.min(bounds.y, position.y)),
});

export const getAnchoredModalPan = ({
  anchor,
  currentPan,
  currentZoom,
  nextZoom,
  viewportCenter,
}) => {
  if (nextZoom === MIN_MODAL_ZOOM) return { x: 0, y: 0 };
  const ratio = nextZoom / currentZoom;
  const offset = {
    x: anchor.x - viewportCenter.x,
    y: anchor.y - viewportCenter.y,
  };

  return {
    x: offset.x - (offset.x - currentPan.x) * ratio,
    y: offset.y - (offset.y - currentPan.y) * ratio,
  };
};
